import BooleanPlugins from "./boolean/PluginSetup.js";
import NumericPlugins from "./numeric/PluginSetup.js";
import StringPlugins from "./string/PluginSetup.js";
import UnitPlugins from "./unit/PluginSetup.js";
import GeoPointPlugins from "./geoPoint/PluginSetup.js";
export default {
  install(opts) {
    BooleanPlugins.install(opts);
    NumericPlugins.install(opts);
    StringPlugins.install(opts);
    UnitPlugins.install(opts);
    GeoPointPlugins.install(opts);
  }
};